import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
import type { SocialButtonType } from './types'

@safeCustomElement('mdc-social-button')
export class MdcSocialButton extends LitElement {
  @property({ type: String }) type: SocialButtonType = 'facebook'

  static styles = css`
		:host {
			display: inline-block;
			font-family: var(--typography-font-family-sans);
			--mdc-social-button-facebook-bg: #1877f2;
			--mdc-social-button-focus-ring: var(--color-functional-blue-300, #0095f6);
			--mdc-social-button-font-family: var(--typography-font-family-sans);
		}

		.mdc-social-button {
			display: inline-flex;
			height: 2.5rem;
			width: 100%;
			padding: var(--spacing-075, 0.75rem) var(--spacing-150, 1.5rem);
			justify-content: center;
			align-items: center;
			gap: var(--spacing-050, 0.5rem);
			border-radius: var(--radius-md, 0.5rem);
			cursor: pointer;
			border: none;
			margin: 0;
			box-sizing: border-box;
		}

		.mdc-social-button:focus-visible {
			box-shadow: 0 0 0 2px var(--mdc-social-button-focus-ring);
			outline: none;
		}

		.mdc-social-button--type-facebook {
			background-color: var(--mdc-social-button-facebook-bg);
			color: var(--color-foreground-interactive-inverse-primary-default, var(--color-functional-gray-white));
		}

		.mdc-social-button--type-google {
			border: 1px solid var(--color-border-interactive-primary-default, var(--color-functional-gray-75));
			background-color: var(--color-background-Interactive-primary-default, var(--color-functional-gray-white));
			color: var(--color-foreground-interactive-primary-default, var(--color-functional-gray-black));
		}

		.mdc-social-button--type-apple {
			background-color: var(--color-background-Interactive-inverse-primary-default, var(--color-functional-gray-black));
			color: var(--color-foreground-interactive-inverse-primary-default, var(--color-functional-gray-white));
		}

		.mdc-social-button__icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
		}

		.mdc-social-button__icon svg {
			width: 1.25rem;
			height: 1.25rem;
		}

		.mdc-social-button__text {
			text-align: center;
			font-family: var(--mdc-social-button-font-family);
			font-size: var(--typography-font-size-068-and-three-quatars, 0.6875rem);
			font-weight: 450;
			line-height: 1;
			letter-spacing: 0.03438rem;
			text-transform: uppercase;
		}
	`

  render() {
    const className = `mdc-social-button mdc-social-button--type-${this.type}`
    const typeLabel = this.type.charAt(0).toUpperCase() + this.type.slice(1)

    return html`
			<button type="button" class=${className}>
				<span class="mdc-social-button__icon"><mdc-icon name=${this.type}></mdc-icon></span>
				<span class="mdc-social-button__text">Continue with ${typeLabel}</span>
			</button>
		`
  }
}
